import { newId } from "@engram/core/id";
import type { Editor, Range } from "@tiptap/core";
import { db } from "../../db/client";

/** Focuses a task's title field once its node view has rendered (its row loads asynchronously). */
export function focusTaskTitle(editor: Editor, id: string, caret: "start" | "end" = "end") {
  let tries = 0;
  const attempt = () => {
    const el = editor.view.dom.querySelector<HTMLInputElement>(`.task-title[data-task="${id}"]`);
    if (el) {
      el.focus();
      const at = caret === "end" ? el.value.length : 0;
      el.setSelectionRange(at, at);
    } else if (tries++ < 40) setTimeout(attempt, 25);
  };
  attempt();
}

/**
 * Creates a task row and drops its placeholder into the note: at `at` (a document position),
 * replacing `range` (the "/" command text), or at the caret.
 */
export async function insertNewTask(editor: Editor, noteId: string, range?: Range, at?: number) {
  const id = newId();
  const now = Date.now();
  await db.mutate([
    {
      t: "tasks",
      id,
      set: { note_id: noteId, title: "", completed_at: null, due_at: null, due_all_day: 0, reminder_at: null, flagged: 0, recurrence: null, position: now, created: now, updated: now },
    },
  ]);
  const node = { type: "taskRef", attrs: { id } };
  if (at != null) editor.chain().insertContentAt(at, node).run();
  else {
    const chain = editor.chain().focus();
    if (range) chain.deleteRange(range);
    chain.insertContent(node).run();
  }
  focusTaskTitle(editor, id);
}
